<template>
  <svg
    t="1689930793724"
    class="icon color-2"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1099"
  >
    <path
      d="M769.365333 277.162667c-40.96-83.968-144.042667-155.648-260.778666-155.648-61.44 0-154.965333 21.162667-224.938667 105.813333-46.762667 56.661333-62.464 122.538667-52.565333 188.757333 6.826667 45.397333 32.085333 105.130667 68.266666 143.018667 13.653333-95.914667 64.170667-171.349333 130.389334-226.645333 119.125333-91.818667 246.784-86.698667 339.626666-55.296z"
      fill="#1bb340"
      opacity=".7"
      p-id="1100"
    ></path>
    <path
      d="M862.549333 420.864c-73.045333-94.890667-199.68-121.514667-313.685333-79.189333 3.754667 1.024 7.509333 2.048 10.922667 3.413333 168.96 57.685333 260.437333 240.981333 204.117333 409.258667-15.018667 44.714667-38.912 83.968-69.290667 116.394666 36.522667-10.24 73.728-24.576 105.472-49.152 129.024-98.645333 154.282667-281.6 62.464-400.725333z"
      fill="#1bb340"
      opacity=".7"
      p-id="1101"
    ></path>
    <path
      d="M508.245333 724.309333c-25.6 0-50.517333-3.072-74.410666-8.192-3.072-0.682667-5.802667-1.024-9.216-0.682666-7.168 0.341333-13.312 2.730667-19.456 6.485333l-78.848 50.517333c-2.048 1.365333-4.437333 2.389333-7.168 2.730667-6.826667 0.341333-12.629333-5.12-12.970667-11.946667 0-3.072 1.024-6.144 1.706667-9.216 0.341333-1.706667 8.874667-39.594667 13.994666-63.488 0.682667-2.730667 1.024-5.12 1.024-7.850666-0.341333-8.192-4.778667-15.36-10.922666-19.456-83.285333-56.661333-140.288-145.749333-152.576-237.568-20.821333 32.768-32.085333 59.050667-43.008 96.938666-40.618667 141.994667 48.469333 312.32 193.536 360.106667 166.912 54.954667 326.314667-6.826667 381.269333-148.821333 6.826667-17.408 13.994667-46.421333 15.36-70.997334-58.368 43.008-120.149333 61.44-198.314667 61.44z"
      fill="#1bb340"
      opacity=".7"
      p-id="1102"
    ></path>
    <path
      d="M508.245333 724.309333c-25.6 0-50.517333-3.072-74.410666-8.192-3.072-0.682667-5.802667-1.024-9.216-0.682666-7.168 0.341333-13.312 2.730667-19.456 6.485333l-78.848 50.517333c-2.048 1.365333-4.437333 2.389333-7.168 2.730667-6.826667 0.341333-12.629333-5.12-12.970667-11.946667 0-3.072 1.024-6.144 1.706667-9.216 0.341333-1.706667 8.874667-39.594667 13.994666-63.488 0.682667-2.730667 1.024-5.12 1.024-7.850666-0.341333-8.192-4.778667-15.36-10.922666-19.456-83.285333-56.661333-140.288-145.749333-152.576-237.568-20.821333 32.768-32.085333 59.050667-43.008 96.938666-40.618667 141.994667 48.469333 312.32 193.536 360.106667 166.912 54.954667 326.314667-6.826667 381.269333-148.821333 6.826667-17.408 13.994667-46.421333 15.36-70.997334-58.368 43.008-120.149333 61.44-198.314667 61.44z"
      fill="#1bb340"
      opacity=".7"
      p-id="1103"
    ></path>
  </svg>
</template>
